import { combine } from 'zustand/middleware';
import { createWithEqualityFn as create } from 'zustand/traditional';

import { IWhoIsWorkingSearchQuery } from 'hooks/whoIsWorking/useFetchWhoIsWorking';

export const initialSearchQuery: IWhoIsWorkingSearchQuery = {
  working: 'true',
  group_ids: '',
};

const searchParamStore = combine(initialSearchQuery, set => ({
  updateSearchQuery: (searchParams: IWhoIsWorkingSearchQuery) => set(prev => ({ ...prev, ...searchParams })),
}));

export const useSearchParamStore = create(searchParamStore);
